import { clearEmptyErrors } from '@shared/lib/validation/clearEmptyErrorsValidation/clear-empty-errors';
import { RegisterFormKeys } from '../../config/form-register-constants';
import { RegisterFormFields } from '../../ui/register-step/types';
import { required } from '@shared/lib/validation/validateRequired/required';
import { validateEmail } from '@shared/lib/validation/validateEmail/validate-email';
import { validatePhone } from '@shared/lib/validation/validatePhone/validate-phone';
import { getOrganizationByInn } from './get-organization-by-inn';
import { OrganizationSuggestItem } from '@shared/model/organization';
import { maxLength } from '@shared/lib/validation/validateMaxLength/max-length';

export const validate = ({
    fields,
    organizations,
}: {
    fields: RegisterFormFields;
    organizations: OrganizationSuggestItem[];
}) => {
    const errors = {} as Record<RegisterFormKeys, string>;
    const chosenOrganization = getOrganizationByInn({ inn: fields[RegisterFormKeys.CompanyINN], organizations });
    if (!chosenOrganization) {
        errors[RegisterFormKeys.CompanyINN] = 'Невалидное значение';
    }

    errors[RegisterFormKeys.Name] =
        required(fields[RegisterFormKeys.Name]) || maxLength(fields[RegisterFormKeys.Name], 100);
    errors[RegisterFormKeys.Surname] =
        required(fields[RegisterFormKeys.Surname]) || maxLength(fields[RegisterFormKeys.Surname], 100);
    errors[RegisterFormKeys.Patronymic] = maxLength(fields[RegisterFormKeys.Patronymic], 100);
    errors[RegisterFormKeys.CompanyINN] = required(fields[RegisterFormKeys.CompanyINN]);
    errors[RegisterFormKeys.CompanyINN] = maxLength(fields[RegisterFormKeys.CompanyINN], 100);
    errors[RegisterFormKeys.JobTitle] = required(fields[RegisterFormKeys.JobTitle]);
    errors[RegisterFormKeys.JobTitle] = maxLength(fields[RegisterFormKeys.JobTitle], 100);
    errors[RegisterFormKeys.Department] = required(fields[RegisterFormKeys.Department]?.[0]?.value);
    errors[RegisterFormKeys.Email] = required(fields[RegisterFormKeys.Email]);
    errors[RegisterFormKeys.Email] = validateEmail(fields[RegisterFormKeys.Email]);
    errors[RegisterFormKeys.Email] = maxLength(fields[RegisterFormKeys.Email], 100);
    errors[RegisterFormKeys.Phone] = validatePhone(fields[RegisterFormKeys.Phone]);

    return clearEmptyErrors(errors);
};
